import { Button, useNavigation } from '@eleveo/components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TEST_IDS } from '../../../constants/dataTestIds';

export const DrawerSideBoxHandle: React.FC = () => {
  const { toggle } = useNavigation();
  const { t } = useTranslation();

  return (
    <Button
      className="drawer__handle"
      variant="quiet"
      onClick={toggle}
      testId={TEST_IDS.buttonNavigationToggle}
      aria-label={t('layout.navigation.toggleDrawer')}
    >
      <svg className="icon" viewBox="0 0 128 128">
        <path d="M74.3 9.4h-2.5c-2.3 0-4.1 1.8-4.1 4.1v100.1c0 2.3 1.8 4.1 4.1 4.1h2.5c2.3 0 4.1-1.8 4.1-4.1V13.5c0-2.2-1.9-4.1-4.1-4.1zM56.3 9.4h-2.5c-2.3 0-4.1 1.8-4.1 4.1v100.1c0 2.3 1.8 4.1 4.1 4.1h2.5c2.3 0 4.1-1.8 4.1-4.1V13.5c0-2.2-1.8-4.1-4.1-4.1z" />
      </svg>
    </Button>
  );
};
